//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  export default {
    data(){
      return {
        find:'',
        patientid: this.$store.state.userInfo.id,
        addressTitle:[],
        orederId: this.$route.query.orederId,
      }
    },
    methods:{
      getcodes(items,type){
        this.$store.state.addressList=items;
        this.$store.state.basePzzy.yishi=items;
//        localStorage.setItem("pzzydoctor", JSON.stringify(items));
        this.$router.push({path: '/pzzyManage',query:{id: this.orederId==null?this.$store.state.orderAddress:this.orederId, befrom: 'orderList', addressType: type, addressInfo: items, isDelivery: 1,addressId: items.id}});
      },
      getMyAddress(){
        let params = {
          parameters: this.patientid
        };
        let _this=this;
        this.$doRequest("/api/doctorinfo/getPhotoDrugDoctors", params, res=>{
          _this.addressTitle=res.parameters;
//          console.log(_this.addressTitle)
        })
      },
      queryDoctor(){
        this.pagination = 1;
        this.patientid=this.find;
        this.getMyAddress();
      }

    },
    created(){
      document.title = '选择医师';
      this.orederId = this.$route.query.id;
    },
    mounted(){
      this.getMyAddress();
    }
  }



// WEBPACK FOOTER //
// ./src/views/pzzydoctorEdit/index.vue